// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.article-modal-panel {
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.article-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.4rem 1.8rem;
  border-bottom: 1px solid #e5e7eb;
}

.article-modal-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.article-modal-close {
  background: none;
  border: none;
  font-size: 2rem;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.article-modal-close:hover {
  color: #374151;
}

.article-modal-body {
  overflow-y: auto;
  padding: 1.4rem 1.8rem;
}

/* Grille d'infos (Réf, Unité) */
.article-modal-info-grid {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
}

.article-modal-info-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.article-modal-info-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.article-modal-info-value {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

/* Sections */
.article-modal-section {
  margin-bottom: 20px;
}

.article-modal-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #595959;
  margin: 0 0 8px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.article-modal-description {
  font-size: 13px;
  color: #374151;
  line-height: 1.7;
  margin: 0;
  white-space: pre-wrap;
}

.article-modal-empty {
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
  margin: 0;
}

/* Tableau des seuils */
.article-modal-seuils-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.article-modal-seuils-table th,
.article-modal-seuils-table td {
  padding: 10px 14px;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.article-modal-seuils-table th {
  font-weight: 600;
  color: #595959;
  background: #f9fafb;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.article-modal-seuils-table td {
  color: #374151;
}

.article-modal-seuils-table tr:last-child td {
  border-bottom: none;
}

.article-modal-seuils-table tbody tr:hover {
  background-color: #f9fafb;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/ArticleDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".article-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 200;\n}\n\n.article-modal-panel {\n  background: #ffffff;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.article-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.4rem 1.8rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.article-modal-title {\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.article-modal-close {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: #6b7280;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n}\n\n.article-modal-close:hover {\n  color: #374151;\n}\n\n.article-modal-body {\n  overflow-y: auto;\n  padding: 1.4rem 1.8rem;\n}\n\n/* Grille d'infos (Réf, Unité) */\n.article-modal-info-grid {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 20px;\n}\n\n.article-modal-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.article-modal-info-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.article-modal-info-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n}\n\n/* Sections */\n.article-modal-section {\n  margin-bottom: 20px;\n}\n\n.article-modal-section-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #595959;\n  margin: 0 0 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.article-modal-description {\n  font-size: 13px;\n  color: #374151;\n  line-height: 1.7;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.article-modal-empty {\n  font-size: 13px;\n  color: #9ca3af;\n  font-style: italic;\n  margin: 0;\n}\n\n/* Tableau des seuils */\n.article-modal-seuils-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.article-modal-seuils-table th,\n.article-modal-seuils-table td {\n  padding: 10px 14px;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.article-modal-seuils-table th {\n  font-weight: 600;\n  color: #595959;\n  background: #f9fafb;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.article-modal-seuils-table td {\n  color: #374151;\n}\n\n.article-modal-seuils-table tr:last-child td {\n  border-bottom: none;\n}\n\n.article-modal-seuils-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
